import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { IFile } from '@shared/model';
import { SnackbarService } from '../../snackbar/snackbar.service';

@Component({
  selector: 'app-upload-file-logo',
  templateUrl: './upload-file-logo.component.html',
  styleUrls: ['./upload-file-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFileLogoComponent implements OnInit {
  @Input() multiple: boolean = false;
  @Input() file: IFile | undefined | null = null;
  @Output() onUploadFiles: EventEmitter<FileList> = new EventEmitter<FileList>();
  @Output() onDeleteFile: EventEmitter<number> = new EventEmitter<number>();

  message = 'GENERAL_INFORMATION_DRAG_AND_DROP_ADDITIONAL_PROJECT_DATA';

  constructor(private _snackbarService: SnackbarService) {}

  ngOnInit(): void {
    this.message = 'GENERAL_INFORMATION_DRAG_AND_DROP_LOGO';
  }

  onFileDropped(fileList: FileList) {
    this._validateFiles(fileList);
  }

  fileBrowseHandler(target: EventTarget | any) {
    this._validateFiles(target.files);
  }

  private _validateFiles(fileList: FileList) {
    if (this.multiple !== false && this.file) {
      // this._snackbarService.openSnackBar('');
      return;
    }

    let isMaxSizeFileError = false;

    for (let i = 0; i < fileList.length; i++) {
      if (fileList.item(i) && fileList.item(i)!.size > 5242880) {
        isMaxSizeFileError = true;
      }
    }

    if (isMaxSizeFileError) {
      this._snackbarService.openSnackBar('Размер файла превышает 5Mb');
      return;
    }

    this.onUploadFiles.emit(fileList);
  }

  renderIcon(type: string): string {
    switch (type) {
      case 'txt':
      case 'doc':
      case 'docx':
      case 'rtf':
        return 'icon-file-text';
      case 'xls':
      case 'xlsx':
        return 'icon-file-excel';
      case 'pdf':
        return 'icon-file-pdf';
      case 'jpg':
      case 'jpeg':
      case 'bmp':
      case 'tiff':
      case 'png':
      case 'gif':
        return 'icon-file-image';
      default:
        return '';
    }
  }
  // TODO: perf - удалить или перенести в утилиту
  renderSize(bytes: number): string {
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }
}
